import { blobClient, client } from '@api/client';
import { URL } from '@api/urls';

import { TExportAssetsDTO, TExportAssetsRulesDTO } from '@interfaces/assets/dto/assetsDTO';
import { IExportPolygonAssetsDTO } from '@interfaces/map/dto/polygonDTO';

const {
	exportAssetRules,
	exportAssetRulesUpdate,
	exportAssetFile,
	exportAssetInfoPolygon,
} = URL;

export const getExportAssetsRules = (): Promise<void> => {
	return client.post(`/${exportAssetRules}`, null);
};

export const updateExportAssetsRules = (dto: TExportAssetsRulesDTO): Promise<void> => (
	client.post(`/${exportAssetRulesUpdate}`, dto)
);

export const getExportAssetsFile = (dto: TExportAssetsDTO): Promise<void> => blobClient.post(exportAssetFile, dto);

export const exportPolygonAssets = (dto: IExportPolygonAssetsDTO): Promise<void> => {
	return client.post(exportAssetInfoPolygon, dto);
};
